import { useTranslation } from 'react-i18next';
import './machinemessage.scss'
import { useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';
import { Machine } from '../../utils/models/Machine';

const MachineMessage = (props: { machine: Machine | null, token: string, onSavedText: (title: string, body: string) => void }) => {
    const { t } = useTranslation();
    const [ediitMode, setEditMode] = useState(false)
    const [title, setTitle] = useState('')
    const [body, setBody] = useState('')



    return (
        <div className='machineMessageContainer text-center rounded-1'>
            <div className='d-flex justify-content-between align-items-center pt-2'>
                <p className="mt-1 ms-3 h4 text-start flex-grow-1">{t('AppNotification')}</p>
                {!ediitMode && <button type='button' onClick={() => setEditMode(true)} className="btn-Custom btn-IDGreen me-3"><i className="bi bi-pencil"></i></button>}
                {ediitMode && <button type='button' onClick={() => setEditMode(false)} className="btn-Custom btn-IDGreen me-2"><i className="bi bi-save"></i></button>}
                {ediitMode && <button type='button' onClick={() => setEditMode(false)} className="btn-Custom btn-IDRed me-3"><i className="bi bi-x-circle "></i></button>}
            </div>
            <Form className='messageForm'>
                <div className='col'>
                    <div className='row text-start'>
                        <Form.Label className='mb-0'>{t('Title')}</Form.Label>
                        <Form.Control disabled={!ediitMode} maxLength={40} name="title" type="text" onChange={(e: any) => setTitle(e.target.value)} value={title} />
                    </div>
                    <div className='row text-start'>
                        <Form.Label className='mb-0'>{t('Message')}</Form.Label>
                        <Form.Control disabled={!ediitMode} maxLength={120} name="descLang" as="textarea" onChange={(e: any) => setBody(e.target.value)} value={body} rows={3} style={{ resize: 'none' }} />
                    </div>
                </div>
            </Form>
        </div>
    )
}

export default MachineMessage